import { getOptionNameByCode, OptionItem } from "@/model/OptionItem";

export enum PeriodTypeEnum {
  DAY = "DAY",
  MONTH = "MONTH",
  YEAR = "YEAR",
}
export const PeriodTypeDict: OptionItem[] = [
  {
    code: PeriodTypeEnum.DAY,
    name: "天",
  },
  {
    code: PeriodTypeEnum.MONTH,
    name: "个月",
  },
  {
    code: PeriodTypeEnum.YEAR,
    name: "年",
  },
];

export const PeriodTypeValue = (val: PeriodTypeEnum): string =>
  getOptionNameByCode(val, PeriodTypeDict);
